import { useTranslation } from 'react-i18next';

import type { ChecklistDto } from './checklistFiltering';
import { sortChecklistsByTitle } from './checklistFiltering';
import { ChecklistListItemComponent } from './ChecklistListItemComponent';

export type ChecklistListComponentProps = {
  checklists: readonly ChecklistDto[] | null | undefined;
};

export function ChecklistListComponent({ checklists }: ChecklistListComponentProps) {
  const { t } = useTranslation();

  if (checklists != null && checklists.length > 0) {
    return (
      <div className="list-group list-group-flush border-bottom border-1">
        {sortChecklistsByTitle(checklists).map((checklist) => (
          <ChecklistListItemComponent key={checklist.id} checklist={checklist} />
        ))}
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center p-4 bg-light" role="alert">
      {t('Checklists_NoChecklistsFound')}
    </div>
  );
}
